import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { submitRSVP, fetchRSVPStats } from "../lib/api";
import MickeyEars from "./MickeyEars";

export const RSVP = () => {
    const [form, setForm] = useState({ name: "", guests: 1, message: "" });
    const [loading, setLoading] = useState(false);
    const [stats, setStats] = useState({ total_confirmations: 0, total_guests: 0 });
    const [submitted, setSubmitted] = useState(false);

    const loadStats = async () => {
        try {
            const s = await fetchRSVPStats();
            setStats(s);
        } catch (e) {
            // silent
        }
    };

    useEffect(() => {
        loadStats();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.name.trim()) {
            toast.error("Por favor, informe seu nome.");
            return;
        }
        const guests = Number(form.guests) || 1;
        if (guests < 1 || guests > 20) {
            toast.error("Número de convidados deve ser entre 1 e 20.");
            return;
        }
        setLoading(true);
        try {
            await submitRSVP({
                name: form.name.trim(),
                guests,
                message: form.message.trim(),
                attending: true,
            });
            toast.success("Presença confirmada! Hot dog! Hot dog! 🎉");
            setForm({ name: "", guests: 1, message: "" });
            setSubmitted(true);
            await loadStats();
        } catch (err) {
            toast.error("Ops, não conseguimos confirmar. Tente novamente.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <section
            id="rsvp"
            data-testid="rsvp-section"
            className="relative py-20 sm:py-28 px-6 polka-red text-primary-foreground"
        >
            <div className="max-w-2xl mx-auto relative">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="bg-white text-foreground border-thick rounded-3xl shadow-pop-lg p-8 sm:p-12"
                >
                    <div className="text-center">
                        <div className="inline-flex items-center justify-center bg-primary text-primary-foreground border-thick rounded-full px-4 py-1 shadow-pop-sm font-heading uppercase tracking-widest text-xs">
                            RSVP
                        </div>
                        <h2 className="font-heading text-4xl sm:text-5xl font-bold mt-4">
                            Confirme sua presença
                        </h2>
                        <p className="mt-3 text-foreground/70">
                            Avise-nos quantos vão na festa para prepararmos os
                            chapeuzinhos do Mickey.
                        </p>

                        <div
                            data-testid="rsvp-stats"
                            className="mt-6 flex items-center justify-center gap-4 flex-wrap"
                        >
                            <div className="bg-secondary text-secondary-foreground border-thick rounded-full px-4 py-1 font-heading text-sm">
                                {stats.total_confirmations} confirmação(ões)
                            </div>
                            <div className="bg-accent text-accent-foreground border-thick rounded-full px-4 py-1 font-heading text-sm">
                                {stats.total_guests} convidado(s)
                            </div>
                        </div>
                    </div>

                    <form onSubmit={handleSubmit} className="mt-8 space-y-5">
                        <div>
                            <label
                                htmlFor="rsvp-name"
                                className="font-heading text-sm uppercase tracking-widest"
                            >
                                Nome Completo
                            </label>
                            <input
                                id="rsvp-name"
                                data-testid="rsvp-name-input"
                                type="text"
                                value={form.name}
                                onChange={(e) =>
                                    setForm({ ...form, name: e.target.value })
                                }
                                className="mt-2 w-full border-thick rounded-2xl px-4 py-3 text-lg bg-white focus:outline-none"
                                placeholder="Ex.: Maria Silva"
                                required
                                maxLength={120}
                            />
                        </div>

                        <div>
                            <label
                                htmlFor="rsvp-guests"
                                className="font-heading text-sm uppercase tracking-widest"
                            >
                                Número de Convidados (incluindo crianças)
                            </label>
                            <input
                                id="rsvp-guests"
                                data-testid="rsvp-guests-input"
                                type="number"
                                min={1}
                                max={20}
                                value={form.guests}
                                onChange={(e) =>
                                    setForm({ ...form, guests: e.target.value })
                                }
                                className="mt-2 w-full border-thick rounded-2xl px-4 py-3 text-lg bg-white focus:outline-none"
                                required
                            />
                        </div>

                        <div>
                            <label
                                htmlFor="rsvp-message"
                                className="font-heading text-sm uppercase tracking-widest"
                            >
                                Mensagem para o Christopher (opcional)
                            </label>
                            <textarea
                                id="rsvp-message"
                                data-testid="rsvp-message-input"
                                value={form.message}
                                onChange={(e) =>
                                    setForm({ ...form, message: e.target.value })
                                }
                                rows={3}
                                maxLength={600}
                                placeholder="Mal posso esperar para te ver na festa!"
                                className="mt-2 w-full border-thick rounded-2xl px-4 py-3 text-base bg-white focus:outline-none resize-none"
                            />
                        </div>

                        <button
                            data-testid="rsvp-submit-button"
                            type="submit"
                            disabled={loading}
                            className="w-full font-heading text-xl bg-primary text-primary-foreground border-thick rounded-full py-4 px-8 shadow-pop hover:-translate-y-1 transition-transform disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-3"
                        >
                            <MickeyEars size={22} color="#fff" />
                            {loading ? "Enviando..." : submitted ? "Enviar outro RSVP" : "Confirmar Presença"}
                        </button>
                    </form>
                </motion.div>
            </div>
        </section>
    );
};

export default RSVP;
